import { EVENT5K } from "@/constants/testIds";
import { Baby, Users, Music, Store, HeartHandshake, Sun, Trophy, Sparkles, Droplets } from "lucide-react";

const FEATURES = [
  { icon: Baby, title: "1-Mile Fun Run", desc: "Youth-focused, beginner-safe, all-smiles route." },
  { icon: Users, title: "Family Walk", desc: "Push strollers, hold hands, cross the line together." },
  { icon: Droplets, title: "Bubble & Fun Zone", desc: "Bubbles, dancing, photo moments before & after the race." },
  { icon: Store, title: "Vendor Village", desc: "Shop, snack, and support local businesses." },
  { icon: HeartHandshake, title: "Community Resources", desc: "Meet partners, mentors, and support programs." },
  { icon: Music, title: "Music & Energy", desc: "Live vibes, hype crew, and cheer squads on course." },
  { icon: Sparkles, title: "Small Business Love", desc: "Every mile funds entrepreneur programs." },
  { icon: Sun, title: "All Fitness Levels", desc: "Run, walk, roll — you belong here." },
  { icon: Trophy, title: "Finisher Energy", desc: "Photos, celebration, and post-race hangs." },
];

export default function FamilyFriendly() {
  return (
    <section data-testid={EVENT5K.sectionFamily} className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#00A651] font-bold mb-4">Family-Friendly Experience</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            Built for <span className="text-[#EC008C]">everyone</span>.
          </h2>
          <p className="mt-4 text-lg text-[#A3A3A3]">
            You don&apos;t have to be a runner. You just have to show up. Bring the family, form a team, or come solo — the vibe is welcoming, energetic, and full of purpose.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-4 gap-4">
          {FEATURES.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              className="group bg-[#141414] border border-[#27272A] p-6 hover:border-[#00A651]/60 transition-all hover:-translate-y-1"
            >
              <Icon className={`w-7 h-7 mb-4 ${i % 2 === 0 ? "text-[#00A651]" : "text-[#EC008C]"}`} />
              <div className="font-display font-bold uppercase text-white text-base tracking-wide">{title}</div>
              <div className="text-sm text-[#A3A3A3] mt-1.5">{desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
